module.exports = __webpack_public_path__ + "img/body-combat.92c44590.jpg";